import { electricPurple000 } from "@habitech/shared";
import styled from "styled-components";

export const WrapperProspects = styled.div`
    background: ${electricPurple000};
    border-radius: 10px;
    padding: 0;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 24px 0px;
    }

    @media ${({ theme }) => theme.screenSizes.laptop} {
        margin: 0 auto;
        padding: 16px 24px;
    }
`;
